<template>
  <page-content v-if="hasPermission('product_delete')" page-title="Xóa sản phẩm theo shop">
    <panel ref="panel" show-close show-collapse title="Điều kiện xóa sản phẩm">
      <c-form ref="form">
        <b-row>
          <b-col>
            <c-select2 v-model.number="model.shopOrder"
                       label="Shop"
                       placeholder="Nhập tên shop hoặc mã shop"
                       uri="cms/api/v1.0/select2/shop"
                       validate-rules="required"
            />
          </b-col>
          <b-col>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <c-input v-model="model.productId" label="ID Sản phẩm"/>
          </b-col>
          <b-col>
            <c-input v-model="model.productName" label="Tên sản phẩm"/>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <c-date-picker v-model="model.fromCreateDate"
                           label="Tạo từ ngày"
            />
          </b-col>
          <b-col>
            <c-date-picker v-model="model.toCreateDate"
                           label="Tạo đến ngày"
            />
          </b-col>
        </b-row>

        <b-row>
          <b-col class="text-center">
            <button class="btn btn-success" @click="search(false)">
              <i class="fas fa-search"></i> Tìm kiếm
            </button>

            <button class="btn btn-success" @click="search(true)">
              <i class="fas fa-search"></i> Tìm kiếm sản phẩm không ảnh
            </button>

            <button class="btn btn-danger" @click="submit()">
              <i class="fas fa-trash-alt"></i> Xóa tất cả
            </button>

            <button class="btn btn-danger" @click="submit(true)">
              <i class="fas fa-trash"></i> Xóa tất cả sản phẩm không có ảnh
            </button>
          </b-col>
        </b-row>
      </c-form>
    </panel>

    <panel v-show="showResultList" ref="resultPanel" show-collapse title="Kết quả tìm kiếm">
      <template #btn>
        <li>
          <a v-b-tooltip.hover title="Load lại dữ liệu" @click="$refs.table.reload()">
            <i class="fas fa-sync-alt"></i>
          </a>
        </li>
        <li>
          <a v-b-tooltip.hover title="Hiển thị thông tin tìm kiếm" @click="showFormSearch = !showFormSearch">
            <i class="fas fa-search"></i>
          </a>
        </li>
      </template>
      <c-table ref="table"
               :data-filter="model"
               :header-configs="[
                   {text: '#', width: '50px'},
                   {text: 'ID sản phẩm', sortField:'id', sortable: true},
                   {text: 'Tên sản phẩm', sortField:'fullName', sortable: true},
                   {text: 'SKU', sortField:'sku', sortable: true},
                   {text: 'Mã sản phẩm', sortField:'code', sortable: true},
                   {text: 'Giá bán', sortField:'retailPrices', sortable: true},
                   {text: 'Thời gian tạo', sortField:'createdAt', sortable: true},
                   {text: 'Người tạo', sortField:'createdBy', sortable: true},
                   {text: 'Thời gian cập nhật', sortField:'updatedAt', sortable: true},
                   {text: 'Người cập nhật', sortField:'updatedBy', sortable: true},
               ]"
               lazy
               uri="/cms/api/v1.0/products/get-all"
      >
        <template #button>
        </template>
        <template #default="{item, index}">
          <td class="text-right">{{ index }}</td>
          <td>{{ item.id }}</td>
          <td>{{ item.fullName }}</td>
          <td>{{ item.sku }}</td>
          <td>{{ item.code }}</td>
          <td>{{ item.retailPrices }}</td>
          <td>{{ item.createdAt | datetime }}</td>
          <td>{{ item.createdBy }}</td>
          <td>{{ item.updatedAt | datetime }}</td>
          <td>{{ item.updatedBy }}</td>
        </template>
      </c-table>
    </panel>
  </page-content>
</template>

<script>
export default {
  name: "Index",
  data() {
    return {
      model: {
        shopOrder: null,
        productId: null,
        productName: null,
        checkImage: false,
        fromCreateDate: null,
        toCreateDate: null,
      },
      showResultList: false,
    }
  },
  methods: {
    search(checkImage) {
      this.$refs.form.validate()
          .then(() => {
            this.model.checkImage = checkImage;
            this.$refs.table.reload()
                .then(success => {
                  this.showResultList = true;
                })
          })

    },
    submit(checkImage) {
      this.$refs.form.validate()
          .then(success => {
            let id = this.model.productId || 0;

            let data = {
              check_image: checkImage,
              product_name: this.model.productName,
              from_create_date: this.model.fromCreateDate ? this.model.fromCreateDate.getTime() : null,
              to_create_date: this.model.toCreateDate ? this.model.toCreateDate.getTime() : null,
            }

            this.$http.delete(`/package-service/v1.0/backdoor/product/${id}`, {
              headers: {
                shop_order: this.model.shopOrder,
                shop_type: 0,
              },
              params: data
            }).then(success => {
              this.$success();
            }).catch(error => {
              this.errorNotify(error)
                  .then(error => {
                    this.$error(error.response.data.message);
                  })
            });
          });
    }
  }
}
</script>

<style scoped>

</style>